/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Data type toggle component which allow users to switch between numerical and categorical
 */

import React from 'react';


import Select from '../common/Select';
import { DropdownIndicator } from '../../utils/dropdown-override';
import ToolTip from '../common/ToolTip';

// Actual DataType Component
class DataTypeComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
        // value: this.props.attributeObj.stats.isNumeric() ? "numerical" : "categorical"
        // To support the subtype along with datatype of the attribute
        value: this.props.attributeObj.getDataType(true)
    };
  }

  changeHandler = (selectedObj) => {
    if(!selectedObj.value) {
      return;
    }

    var _value = selectedObj.value;

    this.setState({
      value: _value
    });

    //pass message to plot on the update of the datatype for attribute
    // mediator.publish( "records:attributeDatatypeUpdated", {
    //   "attributeID": this.props.attributeObj.id,
    //   "dataType": _value
    // });
    // Get access to the parent component and reload it,
    // replace the attributeFilterComponent based on categorical
    // or numerical change
    // this.props.dataType = event.target.value;
    // this.setProps({
    //   dataType : event.target.value
    // });
    // Need help: for some reason this.state doesn't get updated
    // may be its race condition, or I am missing something.
    this.props.handleChange({
      value: _value
    });
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  getTypeOptions = () => {
      if( ! this.typeOptions ) {
          this.typeOptions = [
              // e.g. value: Dyn.dataUtil.types.kNumerical+":"+Dyn.dataUtil.subtypes.kDateTime,
              { value: "categorical", label: this.getLoc("Categorical"), example: 'apple, orange, ...' },
              { value: "categorical:numericIntervals", label: this.getLoc("Categorical: Numerical Intervals"), example: '0-4, 5-9, ..' },
              { value: "numerical", label: this.getLoc("Numerical"), example: '1,234.5678' },
              { value: "numerical:fraction", label: this.getLoc("Numerical: Fraction"), example: '1/4, 3/4, 1 1/2, -4/3' },
              { value: "numerical:extractedNumber", label: this.getLoc("Numerical: Extracted Number"), example: '1234.5678cm, 20%, $5.43' },
              { value: "numerical:datetime", label: this.getLoc("Numerical: Date Time"), example: '2024-04-10 4:01:00 PM, 10/04/2024 4:01am' },
              { value: "numerical:date", label: this.getLoc("Numerical: Date"), example: '2024-04-10, 04/10/2024' },
              { value: "numerical:time", label: this.getLoc("Numerical: Time"), example: '4:01:00 PM' },
              { value: "numerical:duration", label: this.getLoc("Numerical: Duration (Hour : Minute : Second)"), example: '24:01:00, 00:00:01.2' },
              { value: "numerical:durationHM", label: this.getLoc("Numerical: Duration (Hour : Minute)"), example: '24:01, 24:01.2345' },
              { value: "numerical:month", label: this.getLoc("Numerical: Month"), example: 'Jan, Feb, ...' },
              { value: "numerical:monthYear", label: this.getLoc("Numerical: Month Year"), example: 'Jan-1999, February 2000, March, 2021' },
              { value: "numerical:year", label: this.getLoc("Numerical: Year"), example: '1999, 2000, ...' },
              { value: "numerical:yearMonth", label: this.getLoc("Numerical: Year Month"), example: '1999/01, 2000-12' },
              { value: "numerical:dayOfWeek", label: this.getLoc("Numerical: Day of Week"), example: 'Mon, Tue, ...' },
          ];
      }
      return this.typeOptions;
  }

  unitTest = () => {
      let Dyn = this.props.Dyn,
          values = this.getTypeOptions().map( o => /^([\w]+)[:]*([\w]*)/.exec( o.value )),
          valueTypes = values.map( v => v[1] ),
          valueSubtypes = values.map( v => v[2] );
      values.forEach( v =>
          Dyn.assert( Dyn.dataUtil.isSubtypeValidForType( v[1], v[2]), "invalid type:subtype "+v[0] ));
      Dyn.dataUtil.typesArray.forEach( t =>
          Dyn.assert( valueTypes.includes(t), "Data Type menu is missing "+t ));
      Dyn.dataUtil.subtypesArray.forEach( s =>
          Dyn.assert( valueSubtypes.includes(s), "Data Type menu is missing"+s ));
      return true;
  }

  render = () => {
    // var Select = require('react-select');
    var attributeObj = this.props.attributeObj,
        attributeType = this.state.value,
        options = this.getTypeOptions();
    if( ! this.unitTestHasRun ) {
        this.unitTestHasRun = this.unitTest();
    }
    return (
      <div className={"tde-data-type-component tde-row tde-mt-3" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')} aria-label={this.getLoc('Attribute Type')}>
        <div className="tde-label tde-s1-size tde-font-weight-bold tde-attr-name  tde-mb-2">{ this.getLoc('Type') }<ToolTip tip={this.getLoc('Choose type of attribute')} Dyn={this.props.Dyn} dir="r"><i role="button" className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Choose type of attribute')}><span className="tde-sr-only">{this.getLoc('Choose type of attribute')}</span></i></ToolTip></div>
        <Select
            Dyn={this.props.Dyn}
            aria-label={this.getLoc('Select Data Type')}
            className="tde-input tde-select-input tde-input-select tde-data-type"
            isClearable={false}
            tabSelectsValue={false}
            name="data-type"
            value={options.find(obj => obj.value === this.state.value)}
            options={options}
            // openMenuOnFocus
            isSearchable={false}
            menuListMaxHeight="250px"
            components={{
                Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => {
                    const optionId = `react-select-option-${data.value}`;
                    return (
                        <div
                            id={optionId}
                            className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                            title={data.title}
                            role="option"
                            aria-selected={isSelected ? "true" : "false"}
                            {...innerProps}
                            ref={innerRef}
                        >
                            <div className="tde-s1">{children}</div>
                            <div className="tde-subtext-color tde-s2">
                                {data.example}
                            </div>
                        </div>
                    );
                },
                DropdownIndicator
            }}
          onChange={this.changeHandler}
        />
      </div>
    );
  }
}

export default DataTypeComponent;
